<template>
    <td
        v-show="!isStatsFetching"
        class="no-padding"
        colspan="7"
    >
        <vue-slide-up-down
            :active="toggleBtn"
            :duration="durationCollapse"
        >
            <div class="carriers-table">
                <div class="box box-primary">
                    <div
                        v-if="!dataLength"
                        class="box-body"
                    >
                        <p>There are no Carriers found.</p>
                    </div>
                    <div
                        v-else
                        class="box-body table-responsive no-padding"
                    >
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="text-left">ID</th>
                                    <th class="text-left">Carrier</th>
                                    <th class="text-left">Messages</th>
                                    <th class="text-left">Clicks</th>
                                    <th class="text-left">Revenues</th>
                                    <th class="text-left">eCPM/EPC</th>
                                </tr>
                            </thead>
                            <tbody class="carriers-tbody">
                                <tr
                                    v-for="carrier in carriers"
                                    :key="carrier.id"
                                >
                                    <td v-if="carrier.id === 0">
                                        <em class="text-info">None</em>
                                    </td>
                                    <td v-else>{{ carrier.id }}</td>
                                    <td>
                                        <ValueEmpty :value="carrier.name" />
                                    </td>
                                    <td>
                                        <BadgeTotal
                                            :value="carrier.messages_count"
                                            BadgeTotal
                                            color="gray"
                                            title="Total"
                                        />
                                        <BadgeTotal
                                            :value="carrier.messages_sent"
                                            color="green"
                                            title="Sent"
                                        />
                                        <BadgeTotal
                                            :value="carrier.messages_failed"
                                            color="red"
                                            title="Failed"
                                        />
                                        <BadgeTotal
                                            :value="carrier.messages_blacklisted"
                                            color="black"
                                            title="Blacklisted"
                                        />
                                    </td>
                                    <td>
                                        <BadgeTotal
                                            :value="carrier.percentage + '%'"
                                            color="light-blue"
                                            title="Percentage"
                                        />
                                        <BadgeTotal
                                            :value="carrier.clicks_count"
                                            color="aqua-active"
                                            title="Amount"
                                        />
                                    </td>
                                    <td>
                                        <BadgeTotal
                                            :value="'$' + carrier.revenues_prepared_value"
                                            color="light-blue"
                                            title="Amount"
                                        />
                                        <BadgeTotal
                                            :value="carrier.revenues_count"
                                            color="aqua-active"
                                            title="Count"
                                        />
                                    </td>
                                    <td>
                                        <BadgeTotal
                                            :value="carrier.ecpm_prepared_value"
                                            color="light-blue"
                                            title="eCPM"
                                        />
                                        <BadgeTotal
                                            :value="carrier.epc_prepared_value"
                                            color="aqua-active"
                                            title="EPC"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </vue-slide-up-down>
    </td>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ValueEmpty from '../../subcomponents/ValueEmpty';

export default {
    components: {
        ValueEmpty,
        BadgeTotal,
    },
    props: {
        carriers: {
            type: [Object, Array],
            default: () => [],
        },

        isStatsFetching: {
            type: Boolean,
            default: true,
        },

        toggleBtn: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            durationCollapse: 700,
        };
    },
    computed: {
        dataLength: function () {
            return !this.isStatsFetching ? _.size(this.carriers) : 0;
        },
    },
    methods: {
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
    },
};
</script>
